<template>
    <div class="tabs-center" style="max-width: 500px; margin: 0 auto">
        <a-form
                :model="formInline"
                name="basic"
                autocomplete="off"
                @error="handleError"
        >
            <a-tabs v-if="!openPwd">
                <a-tab-pane key="1" tab="密码登录">

                    <a-form-item
                            name="account"
                            :rules="[{ required: true, message: '请输入手机号或用户名' }]"
                    >
                        <a-input size="large" v-model:value="formInline.account"
                                 placeholder="请输入手机号或用户名"/>
                    </a-form-item>

                    <a-form-item
                            name="password"
                            :rules="[{ required: true, message: '请输入密码' }]"
                            :help="formErrors.passwordError"
                    >
                        <a-input-password size="large" v-model:value="formInline.password"
                                          placeholder="请输入密码"/>
                    </a-form-item>

                    <a-form-item>
                        <a-checkbox v-model:checked="formInline.resource">记住密码</a-checkbox>
<!--                        <a href="" style="float: right">忘记密码</a>-->
                    </a-form-item>
                    <div style="text-align: center; margin-bottom: 15px">
                        <a-button size="large" type="primary" block @click="handleSubmit">登&nbsp;&nbsp;录</a-button>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="2" tab="验证码登录">
                    <div>
                        <a-form-item
                                name="tel"
                                :validate-status="formErrors.telError ? 'error' : ''"
                                :help="formErrors.telError"
                                :rules="[{ required: true, message: '请输入常用手机号' }]"
                        >
                            <a-input size="large" v-model:value="formInline.tel" placeholder="请输入常用手机号"/>
                        </a-form-item>
                        <a-form-item
                                name="code"
                                :validate-status="formErrors.codeError ? 'error' : ''"
                                :help="formErrors.codeError"
                                :rules="[{ required: !isDEV, message: '请输入手机验证码' }]"
                        >
                            <a-input size="large" v-model:value="formInline.code" placeholder="请输入手机验证码" style="width: 50%"/>
                            <a-button size="large" style="float: right;width: 48%" @click="getCode" block :disabled="disabled">{{btnText}}</a-button>

                        </a-form-item>
                        <a-form-item v-if="unRegister">
                            <a-checkbox v-model:checked="formInline.resource">未注册手机号将自动注册</a-checkbox>
                        </a-form-item>
                        <div style="text-align: center; margin-bottom: 15px">
                            <a-button size="large" type="primary" @click="handleSubmitByCode">登&nbsp;&nbsp;录 / 注&nbsp;&nbsp;册</a-button>
                        </div>
                    </div>
                </a-tab-pane>
            </a-tabs>

            <div v-else>
                <h3 style="text-align: center">设置密码</h3>
                <a-form-item
                        :validate-status="formErrors.password1Error ? 'error' : ''"
                        :help="formErrors.password1Error"
                        :rules="[
                ({  }) => ({
                                  validator(_, value) {
                                    if(value){
                                      if(value.length < 6) return Promise.reject(new Error('密码至少6位'));
                                      if(!/[A-Z]/.test(value)) return Promise.reject(new Error('密码必须包含大写字母'));
                                      if(!/\d/.test(value)) return Promise.reject(new Error('密码必须包含数字'));
                                    }
                                  },
                                }),
                ]"
                >
                    <a-input-password size="large" v-model:value="formValues.password1" placeholder="请输入密码"/>
                </a-form-item>
                <a-form-item
                        name="confirm"
                        :validate-status="formErrors.confirmError ? 'error' : ''"
                        :help="formErrors.confirmError"
                        :rules="[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (!value || getFieldValue('password1') === value) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('两个密码不一致!'));
                                  },
                                }),
                                ]"
                >
                    <a-input-password size="large" v-model:value="formValues.confirm"  placeholder="请再次输入密码"/>
                </a-form-item>

                <div style="text-align: center; margin-bottom: 15px">
                    <a-button size="large" type="primary" @click="()=>handleSubmitByCode1(true)" block>确 定</a-button>
                </div>

                <div style="text-align: center; margin-bottom: 15px">
                    <a-button size="large" @click="()=>handleSubmitByCode1(false)" block>以 后</a-button>
                </div>
            </div>

        </a-form>
    </div>
</template>

<script>
    import {
        login_success
    } from '@/utils/api';
    import {isDEV, get_args, xTokenKey} from '@/utils/request';
    import {jy_tip} from '@/utils/vue.tool';
    import {isMobile} from '@/utils/llm.tools';
    import {
        post_auth_code_login,
        post_auth_register_tel,
        post_auth_token_password,
        post_auth_token_tel,
        put_auth_password_reset_token,
    } from "../utils/paper.account";
    import {post_grant_genetic} from "../utils/api";
    import {post_biogpt_admin_points_coupon_redeem} from "../utils/bioinfo.api";
    const handleSuccessJump = (values)=>{
        login_success(values.account, values.password);
        if(isMobile()) {
            window.location.href = '/';
            return;
        }
        let href2 = window.location.href || sessionStorage.getItem('href');
        console.log(href2);
        if(href2 && href2.startsWith('/login/')) window.location.href = '/';
        else window.location.reload();
    };

    const handleSuccess = (values)=>{
        login_success(values.account, values.password);
        let {code, points} = get_args();
        if(code) post_biogpt_admin_points_coupon_redeem({coupon_code: code}, (res)=>{
            let {status, message} = res;
            if(status === 1000001) jy_tip('兑换成功，已为您到账 '+points+' 积分。', 'success');
            else if(status === 1201315) jy_tip('兑换失败，该兑换码未生效');
            else if(status === 1201316) jy_tip('兑换失败，该兑换码已过期');
            else if(status === 1201317) jy_tip('兑换失败，该兑换码已被使用');
            else if(status === 1201318) jy_tip('兑换失败，该兑换码已作废');
            else jy_tip('兑换失败，' + message);
            setTimeout(()=>{
                handleSuccessJump(values)
            }, 2000);
        });
        else {
            handleSuccessJump(values)
        }
    };

    export default {
        name: "LoginView",
        components: {
        },
        data() {
            return {
                isDEV,
                openPwd: false,
                formInline: {
                    account: '',
                    password: '',
                    resource:[],

                },
                business: '',
                unRegister: false,
                password_set: false,
                btnText: '获取验证码',
                formErrors: {
                    telError: ''
                },
                formValues: {},
                disabled: false
            };
        },
        created(){

        },
        methods: {
            handleSubmit() {
                console.log('handleSubmit:');
                let {account, password} = this.formInline;
                post_auth_token_password({account, password}, (res)=>{
                    console.log('post_auth_token_password', res);
                    this.handleUserInfo(res, (status, message)=>{
                        if (status === 901) this.setError('password', '密码超过五次不正确，账户已被锁定。请二十分钟后重试');
                        else if (status === 10401) this.setError('password', `密码第${message[message.length - 1]}次输入不正确。输入错误超过五次，将锁定账户，请谨慎`);
                        else if (status === 10501) this.setError('account', `账户${account}不存在, 请检查或注册`);
                        else jy_tip(`登录失败, ${message}。请稍后重试或者联系管理员`);
                    });
                });
            },
            handleError(erros){
                console.log('errors', erros);
            },
            handleSubmitByCode() {
                if(!this.password_set) this.openPwd = true;
                else this.handleSubmitByCode1();
            },
            handleSubmitByCode1(setPwd) {
                let {tel, code} = this.formInline;
                let {password1: password, confirm} = this.formValues;
                let rq = {tel, code};
                if(setPwd){
                    if(!password) {
                        this.setError('password1', '至少为6个字符，需包含大写字母和数字');
                        return;
                    }
                    if(!confirm){
                        this.setError('confirm', '需要再次输入密码');
                        return;
                    }
                    if(confirm !== password){
                        this.setError('confirm', '两次密码不一致');
                        return;
                    }
                    rq.password = password;
                }
                else {
                    this.setError('password1', '');
                    this.setError('confirm', '');
                }
                console.log('验证码登录rq', rq);
                if(this.unRegister) {
                    post_auth_register_tel(rq, (res)=>{
                        let {data} = res;
                        if(data){
                            let {user_info} = data;
                            post_grant_genetic(user_info.account, 'JINGDu', (res2)=>{
                                let {status, message} = res2;
                                if(status === 1000002) {
                                    this.loginSuccessByCode(res);
                                }else jy_tip('授权失败, 请联系管理员:' + message)
                            })
                        }
                    });
                } else post_auth_token_tel(rq, res=>{
                    let {data} = res;
                    if(setPwd && data?.access_token){
                        put_auth_password_reset_token({new_password: password, access_token: data.access_token}, (res2)=>{
                            if(res2.status === 10410) jy_tip('提示：密码设置超时，为保障账户安全，请前往个人中心设置密码。');
                            this.loginSuccessByCode(res);
                        })
                    }else this.loginSuccessByCode(res);
                });
            },
            handleUserInfo(res, func){
                let {status, message} = res;
                let {user_info, access_token, refresh_token} = res?.data || {};
                if(refresh_token) localStorage.setItem('refresh_token', refresh_token);
                if(access_token) localStorage.setItem(xTokenKey, access_token);
                if(user_info) {
                    localStorage.setItem('user_info', JSON.stringify(user_info));
                    handleSuccess(user_info);
                }
                else func(status, message);
            },
            loginSuccessByCode(res){
                console.log('验证码登录 res', res);
                this.handleUserInfo(res, (status, message)=>{
                    if(status === 10404){
                        this.openPwd = false;
                        this.setError('code', '验证码错误');
                    }else if(status === 10405){
                        this.openPwd = false;
                        this.setError('code', '验证码已超时，请重新获取');
                    } else this.setError('password', message)
                });
            },
            getCode(){
                let {tel} = this.formInline;
                if(!tel){
                    this.setError( 'tel', '请输入手机号');
                    return;
                }else this.setError( 'tel', '');
                let s = 60;
                const timer = setInterval( () => {
                    s -- ;
                    this.disabled = true;
                    this.btnText = `${s}秒后重新获取`;
                    if(s <= 0) {
                        this.disabled = false;
                        clearInterval(timer);
                        this.btnText = '重新获取验证码';
                    }
                }, 1000);
                post_auth_code_login({tel}, (res)=>{
                    let {status, data, message} = res;
                    if(status === 1){
                        let {business, password_set} = data || {};
                        this.password_set = password_set;
                        this.unRegister = business === 'register';
                    }else this.setError('tel', message);
                });

            },
            setError(key, msg){
                this.formErrors[key + 'Error'] = msg;
                // obj.$refs.formRef.validateField(msg);
            }
        },
    }
</script>

<style scoped>
    .tabs-center {
        padding: 20px;
    }

    /* 自定义样式 */
    .custom-tabs :deep(.ant-tabs-tab) {
        padding: 12px 24px;
        font-size: 16px;
    }

    /* 确保在响应式下也能居中 */
    .custom-tabs :deep(.ant-tabs-nav) {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
    .loginHeader span{
        font-size: 25px;
        font-weight: 700;
    }
    .siteSummary ul{
        list-style: none;
        padding: 0;
    }
    .siteSummary ul li{
        margin-top: 10px;
        list-style: none;
    }
    @media screen and (min-width: 1200px){
        .loginTipsWrapper{
            padding: 20px 30px;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            flex-direction: column;
            min-height: 100%;
        }
        .loginBoxWrapper{
            background-color: #ffffff;
            padding: 20px;
            width: 400px;
            height: 100%;
            border-radius: 5px;
        }
    }
    @media screen and (min-width: 769px) and (max-width: 1200px){

        .loginBoxWrapper{
            background-color: #ffffff;
            padding: 20px;
            width: 400px;
            height: 100%;
            border-radius: 5px;
        }
    }
    @media screen and (max-width: 768px){

        .loginBoxWrapper{
            background-color: #ffffff;
            padding: 20px;
            width: 100%;
            border-radius: 5px;
        }
    }

</style>

